export const isOperational = day => {
  return day?.operational;
};
